









import Vue from 'vue';
import SystemMessage from '@/components/SystemMessage.vue';

export default Vue.extend({
  name: 'TextBox',
  components: {
    SystemMessage
  },
  props: {
    message: String
  },
  computed: {
    system(): boolean {
      return this.message.startsWith("<");
    },
    parsedMessage(): string {
      return this.message.replace(/</gi, '').replace(/>/gi, '');
    }
  }
});
